import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { conditionFormChecker, putField } from "../../../../../utils/form";

const UseRateList = defineAsyncComponent(() => import("./UseRateList"));

export const createField = ({ props, data, key /* , isLoading */ }) => {
    const { viewOnly, menuContext } = props;
    //const { useForm } = data;
    //const { modelRef } = useForm;
    //const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                visible: () => true,
                colProp: () => ({ xs: 24, class: "mt-3" }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}useRates`,
                            fetchCriteria: data.useRate?.fetchCriteria,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "UseRateList" } })
                    );
                    return <UseRateList {...componentProp}></UseRateList>;
                }
            }
        ]
    });
};
